import AuthService from "../services/auth.service";

export const register = (username, email, password) => (dispatch) => {
  return AuthService.register(username, email, password).then(
    (response) => {
      dispatch({
        type: "REGISTER_SUCCESS",
      });

      dispatch({
        type: "SET_MESSAGE",
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: "REGISTER_FAIL",
      });

      dispatch({
        type: "SET_MESSAGE",
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const login = (username, password, direct = false) => (dispatch) => {

  return AuthService.login(username, password, direct).then(
    (data) => {
      if (data?.data?.data !== undefined && data?.data?.data !== null && data?.data?.data !== "") {
        localStorage.setItem("user", JSON.stringify(data?.data?.data));
        console.log('Login', data?.data?.data)
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: { user: data },
        });
      }

      return Promise.resolve({ user: data });
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: "LOGIN_FAIL",
      });

      dispatch({
        type: "SET_MESSAGE",
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const logout = () => (dispatch) => {
  return AuthService.logout().then(
    (data) => {
      localStorage.removeItem('user');
      localStorage.removeItem("proxy");
      dispatch({
        type: "LOGOUT",
        // payload: { user: data },
      });

      return Promise.resolve(data);
    }
  ).catch((err) => {
    return Promise.reject(err);
  })
};
